import { useContext } from 'react';

import { BreakpointContext } from '../contexts';

/** Programmatic hook access to global responsive design breakpoint statuses. */
export function useBreakpoints() {
  const context = useContext(BreakpointContext);
  return context;
}
